module.exports = __webpack_public_path__ + "img/arrow-down.84965586.svg";